import {Component, OnInit} from '@angular/core';
import {ClientProgram} from "../../core/interfaces/ClientProgram";
import {GonvarriClientProgramAdapter} from "../../core/adapters/gonvarri-client-program.adapter";
import {Observable, of} from "rxjs";
import {BaseSiteService} from "@spartacus/core";
import {GonvarriMap} from "../../core/interfaces/GonvarriMap";
import {GonvarriProduct} from "../../core/models/gonvarri-product.model";
import {LaunchDialogService} from "@spartacus/storefront";
import {take} from "rxjs/operators";
import {GonvarriCartUiEventAddToCart} from "../../core/events/GonvarriCartUiEventAddToCart";

@Component({
    selector: 'app-gonvarri-program-client-table',
    templateUrl: './gonvarri-program-client-table.component.html',
    styleUrl: './gonvarri-program-client-table.component.scss',
    standalone: false
})
export class GonvarriProgramClientTableComponent implements OnInit {

  selectedProduct: GonvarriProduct | undefined;

  contract$: Observable<ClientProgram> = of({} as ClientProgram);
  siteUid: string = "";
  numberFormatter: Intl.NumberFormat = new Intl.NumberFormat("de-DE", {
    maximumFractionDigits: 0
  });

  constructor(
    private adapter: GonvarriClientProgramAdapter,
    private baseSiteService: BaseSiteService,
    private launchDialogService: LaunchDialogService
  ) {}

  ngOnInit() {
    this.contract$ = this.adapter.getCurrentClientProgram();
    this.baseSiteService.getActive().subscribe(baseSite => this.siteUid = baseSite);
  }

  formatDate(curDate: string | undefined): string {
    const date = new Date(curDate as string);
    const PATTERN = "dd/MM/yyyy";
    const DAY = String(date?.getDate());
    const MONTH = String((date?.getMonth() as number) + 1);
    const YEAR = String(date?.getFullYear());
    return PATTERN.replaceAll("dd", DAY).replaceAll("MM", MONTH).replaceAll("yyyy", YEAR);
  }

  formatNumber(value: any): string {
    if(value === undefined || value === null) {
      value = 0;
    }
    value = Number(value);
    return this.numberFormatter.format(value);
  }

  getStockLevel(stockLevel: Array<{ key: string, value: string }>, productCode: string | undefined): number {
    return Number(stockLevel.find(stock => stock.key === productCode)?.value.split("=")[1]);
  }

  getLastOrder(lastOrder: Array<{ key: string, value: string }>, productCode: string | undefined): string {
    return lastOrder.find(stock => stock.key === productCode)?.value as string;
  }

  getContractReference(contractReferences: Array<GonvarriMap>, contractId: string): string {
    return contractReferences.find(contract => contract.key === contractId)?.value as string;
  }

  resetSelectedProduct(): void {
    this.selectedProduct = undefined;
  }

  selectProduct(event: MouseEvent, product: GonvarriProduct): void {
    const addToCartData = this.generateEventDataObject(product);
    const dialog = this.launchDialogService.openDialog(
      "GONVARRI_ADDED_TO_CART",
      undefined,
      undefined,
      addToCartData
    );
    if (dialog) {
      dialog.pipe(take(1)).subscribe();
    }
  }

  generateEventDataObject(product: GonvarriProduct): GonvarriCartUiEventAddToCart {
    const cartUiData = new GonvarriCartUiEventAddToCart();
    cartUiData.quantity = 1;
    cartUiData.product = product;
    cartUiData.numberOfEntriesBeforeAdd = 0;
    cartUiData.pickupStoreName = undefined;
    cartUiData.lenght = String(product.standardLength);
    return cartUiData;
  }

}
